import { __ } from '@wordpress/i18n'
import _ from 'lodash'
import { getCurrentLangWithAttribute } from '../../react/helpers'
import { _k } from '../languages/language.js'

export default class QuoteRequest {
    /* Init
    -------------------------------------------------------------- */
    constructor() {
        // Set class variables
        this.products = []
        this.productsData = []
        this.settings = []

        this.init()
    }

    async init() {
        // Get settings
        try {
            this.settings = await this.fetchSettings()
        } catch (e) {
            console.error(e)

            this.settings = []
            return false
        }

        // Get quote infos from localStorage
        this.getQuoteInfos()
        window.addEventListener('focus', () => {
            this.getQuoteInfos()
        })

        // Set events for 'add to quote' buttons
        this.initAddButton()

        // Init quote request page
        this.initQuotePage()
    }

    /* localStorage
    -------------------------------------------------------------- */
    getQuoteInfos() {
        let quoteInfos = JSON.parse(localStorage.getItem('kpc-quote-infos'))

        if (_.isEmpty(quoteInfos)) return

        if (!_.isEmpty(quoteInfos['products']) && _.isArray(quoteInfos['products'])) {
            this.products = quoteInfos['products']
        }

        this.updateQuoteCounter()
    }

    saveQuoteInfos() {
        localStorage.setItem(
            'kpc-quote-infos',
            JSON.stringify({
                products: this.products,
            })
        )
    }

    /* Buttons
    -------------------------------------------------------------- */
    initAddButton() {
        let buttons = document.getElementsByClassName('kpc-add-product-to-quote')

        for (let btn of buttons) {
            btn.addEventListener('click', this.addProduct.bind(this), false)
        }
    }

    /* Products
    -------------------------------------------------------------- */
    addProduct(event) {
        let buttonEl = event.target.closest('.kpc-add-product-to-quote'),
            prodId = buttonEl.dataset.id,
            prodListKey = _.findKey(this.products, { id: prodId })

        if (prodListKey) {
            this.products[prodListKey].quantity++
        } else {
            this.products.push({
                id: prodId,
                quantity: 1,
            })
        }

        this.saveQuoteInfos()
        this.updateQuoteCounter()
    }

    updateProduct(inputEl) {
        let productId = inputEl.dataset.productId,
            newQuantity = inputEl.value

        if (!_.isEmpty(productId)) {
            let prKey = _.findKey(this.products, { id: productId })

            this.products[prKey].quantity = parseInt(newQuantity)

            this.saveQuoteInfos()
            this.updateQuoteCounter()
        }
    }

    removeProduct(productId) {
        if (!_.isEmpty(productId)) {
            _.remove(this.products, (pr) => {
                return pr.id == productId
            })

            this.saveQuoteInfos()
            this.updateQuoteCounter()
            this.buildProductTable()
        }
    }

    removeAllProducts(withRebuildTable = true) {
        this.products = []

        this.saveQuoteInfos()
        this.updateQuoteCounter()

        if (withRebuildTable) {
            this.buildProductTable()
        }
    }

    /* Quote counter
    -------------------------------------------------------------- */
    updateQuoteCounter() {
        // Get quantity settings
        let stQuantity = _.find(this.settings, { name: 'quoteEnableQuantity' }),
            quantityIsEnable = !_.isEmpty(stQuantity) && stQuantity.value == '0' ? false : true

        let totalQuantity = _.sumBy(this.products, 'quantity'),
            widgetEl = document.getElementById('kpc-quote-widget'),
            counterEl = document.getElementById('kpc-quote-counter')

        if (!widgetEl) return

        if (totalQuantity > 0) {
            widgetEl.classList.add('kpc-quote-widget-active')
            if (quantityIsEnable) counterEl.innerHTML = totalQuantity
        } else {
            widgetEl.classList.remove('kpc-quote-widget-active')
            if (quantityIsEnable) counterEl.innerHTML = ''
        }
    }

    /* Quote Request Page
    -------------------------------------------------------------- */
    async initQuotePage() {
        let pageEl = document.getElementById('kpc-quote-form-page')

        // Quit function if the current page is not Quote Request Page
        if (_.isNil(pageEl)) return false

        // Reset products localStorage if form submit is done
        let successAlertEl = document.getElementsByClassName('kpc-quote-form-succed')

        if (!_.isNil(successAlertEl) && successAlertEl.length > 0) {
            this.removeAllProducts(false)
        }

        // Get product list
        try {
            this.productsData = await this.fetchProducts()
        } catch (e) {
            console.error(e)

            this.productsData = []
            return false
        }

        this.buildProductTable()
    }

    buildProductTable() {
        let tbodyEl = document.querySelector('#kpc-quote-table tbody'),
            renderHtml = ''

        // Get quantity settings
        let stQuantity = _.find(this.settings, { name: 'quoteEnableQuantity' }),
            quantityIsEnable = !_.isEmpty(stQuantity) && stQuantity.value == '0' ? false : true

        if (_.isEmpty(this.products)) {
            renderHtml += `
                <tr>
                    <td colspan="2">
                        ${_k('No products', getCurrentLangWithAttribute())}
                    </td>
                </tr>
            `
        } else {
            for (let pr of this.products) {
                let prData = _.find(this.productsData, { post_id: parseInt(pr.id) })
                let prImageHtml = ''

                if (_.isEmpty(prData)) {
                    continue
                }

                if (!_.isEmpty(prData.medias)) {
                    prImageHtml = `
                        <div class="kpc-product-image">
                            <img src="${prData.medias[0].url}" alt="" />
                        </div>
                    `
                }

                // Build quantity input
                let quantityInput = ''

                if (quantityIsEnable) {
                    quantityInput = `
                        <div class="kpc-form-group">
                            <div class="kpc-input-group">
                                <div class="kpc-input-group-prepend">
                                    <button class="kpc-button kpc-change-quantity" type="button" data-kpc-mode="-">
                                        -
                                    </button>
                                </div>
                                <input
                                    class="kpc-form-control kpc-quantity-number"
                                    type="number"
                                    name="quantity-${pr.id}"
                                    min="0"
                                    value="${pr.quantity}"
                                    data-product-id="${pr.id}"
                                />
                                <div class="kpc-input-group-append">
                                    <button class="kpc-button kpc-change-quantity" type="button" data-kpc-mode="+">
                                        +
                                    </button>
                                </div>
                            </div>
                        </div>
                    `
                } else {
                    quantityInput = `
                        <input
                            type="hidden"
                            name="quantity-${pr.id}"
                            value="1"
                        />
                    `
                }

                renderHtml += `
                    <tr>
                        <td class="kpc-col-products">
                            <a href="${prData.post_url}" title="${prData.post.post_title}">
                                ${prImageHtml}
                                <p class="kpc-product-title">${prData.post.post_title}</p>
                                <p class="kpc-product-model-name">${prData.model_name}</p>
                            </a>
                        </td>
                        <td class="kpc-col-quantity">
                            <div class="kpc-wrap">
                                ${quantityInput}
                                <div class="kpc-remove-product" data-product-id="${pr.id}">
                                    <img
                                        src="${kpc_loc.kiensoCatalogUrl}/images/ico-trash.svg"
                                        alt="${_k('Remove product', getCurrentLangWithAttribute())}"
                                    />
                                </div>
                            </div>
                        </td>
                    </tr>
                `
            }
        }

        tbodyEl.innerHTML = renderHtml
        this.productTablePostRender()
    }

    productTablePostRender() {
        // Set quantity buttons events
        let buttonsEl = document.getElementsByClassName('kpc-change-quantity')

        if (buttonsEl.length > 0) {
            for (let btnEl of buttonsEl) {
                btnEl.addEventListener('click', (ev) => {
                    let el = ev.target

                    let inputEl = el
                        .closest('.kpc-col-quantity')
                        .getElementsByClassName('kpc-quantity-number')[0]

                    if (!_.isNil(inputEl)) {
                        let newValue = inputEl.value

                        switch (el.dataset.kpcMode) {
                            case '+':
                                newValue++
                                break
                            case '-':
                                newValue--
                                break
                        }

                        inputEl.value = newValue > 0 ? newValue : 0

                        this.updateProduct(inputEl)
                    }
                })
            }
        }

        // Set quantity inputs events
        let inputsEl = document.getElementsByClassName('kpc-quantity-number')

        if (inputsEl.length > 0) {
            for (let inputEl of inputsEl) {
                inputEl.addEventListener('input', (ev) => {
                    this.updateProduct(inputEl)
                })
            }
        }

        // Set remove product events
        let removeEl = document.getElementsByClassName('kpc-remove-product')

        if (removeEl.length > 0) {
            for (let rmEl of removeEl) {
                rmEl.addEventListener('click', (ev) => {
                    let el = ev.target.closest('.kpc-remove-product')

                    this.removeProduct(el.dataset.productId)
                })
            }
        }
    }

    fetchProducts() {
        return new Promise((resolve, reject) => {
            // Get the category id
            let postIds = _.map(this.products, 'id')

            // Prepare URL
            let apiUrl = new URL(kpc_loc.endpoint + '/products/list'),
                searchParams = new URLSearchParams({})

            searchParams.append(`with_media_url`, 1)
            searchParams.append(`with_post_url`, 1)

            if (!_.isEmpty(postIds)) {
                _.each(postIds, (v) => {
                    searchParams.append(`post_ids[]`, v)
                })
            }

            apiUrl.search = searchParams.toString()

            fetch(apiUrl, {
                method: 'GET',
                // headers: headers,
                mode: 'cors',
                cache: 'default',
            })
                .then((response) => {
                    return response.json()
                })
                .then((result) => {
                    if (result.status == 'DONE') {
                        resolve(result.data)
                    } else {
                        reject(result.status)
                    }
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    fetchSettings() {
        return new Promise((resolve, reject) => {
            // Get the category id
            let postIds = _.map(this.products, 'id')

            // Prepare URL
            let apiUrl = new URL(kpc_loc.endpoint + '/settings')

            fetch(apiUrl, {
                method: 'GET',
                // headers: headers,
                mode: 'cors',
                cache: 'default',
            })
                .then((response) => {
                    return response.json()
                })
                .then((result) => {
                    if (result.status == 'DONE') {
                        resolve(result.data)
                    } else {
                        reject(result.status)
                    }
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }
}
